import { Tooltip } from 'antd'
import type { BulkOrderUpdateJobSummaryResponse } from '@api/useBulkOrderUpdate/types'

interface ProgressRendererProps {
  data: BulkOrderUpdateJobSummaryResponse
}

export function ProgressRenderer({ data }: ProgressRendererProps) {
  const { progress, current_progress, total_count } = data
  const progressPercentage = Math.round((progress || 0) * 100)

  const getProgressColor = (status: string) => {
    switch (status) {
      case 'completed':
        return 'bg-green-500'
      case 'failed':
      case 'cancelled':
        return 'bg-red-500'
      case 'running':
        return 'bg-blue-500'
      default:
        return 'bg-gray-400'
    }
  }

  return (
    <div className='flex items-center gap-2'>
      <div className='flex-1 bg-gray-200 rounded-full h-2'>
        <div
          className={`h-2 rounded-full transition-all duration-300 ${getProgressColor(data.status)}`}
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      <Tooltip title={`${current_progress || 0} / ${total_count || 0} processed`}>
        <span className='text-xs text-gray-600 w-12 text-right'>{progressPercentage}%</span>
      </Tooltip>
    </div>
  )
}
